/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { IoMenu, IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import meya_logo from '../../assets/images/logo_meya.png';
import './JobNavBar.css';

function JobNavBar({ isJobLoggedIn, onJobLogout, regName, permitdata }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const isShopMember = (() => {
    if (
      permitdata &&
      permitdata.role !== 'guest' &&
      permitdata.token &&
      permitdata.token !== '-' &&
      permitdata.shop_id &&
      permitdata.shop_id !== '-'
    ) {
      return true;
    }
    try {
      const stored = sessionStorage.getItem('meya-token4');
      if (stored && stored !== 'undefined') {
        const parsed = JSON.parse(stored);
        if (
          parsed &&
          parsed.role !== 'guest' &&
          parsed.token &&
          parsed.token !== '-' &&
          parsed.shop_id &&
          parsed.shop_id !== '-'
        ) {
          return true;
        }
      }
    } catch (e) {}
    return false;
  })();
  const onlineShopPath = isShopMember
    ? '/marketplace?category=รวมสินค้า'
    : isJobLoggedIn
      ? '/marketplace?category=สินค้าโปรโมชั่น&&transaction=FNYG18ZWHu'
      : '/';

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('job-drawer-open');
    } else {
      document.body.classList.remove('job-drawer-open');
    }
    return () => document.body.classList.remove('job-drawer-open');
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
    setIsProfileDropdownOpen(false);
  };

  const handleMenuClick = (menuName) => {
    setIsProfileDropdownOpen(false);
    setIsMenuOpen(false);

    if (menuName === 'สร้าง/แก้ไขโปรไฟล์') {
      navigate('/jobs/profile?tab=edit_candidate');
      return;
    } else if (menuName === 'สำหรับผู้ประกอบการ') {
      if (!isShopMember) {
        navigate('/jobs');
        return;
      }
      navigate('/jobs/employer');
      return;
    }

    let tab = 'profile';
    if (menuName === 'บันทึกการค้นหา') tab = 'searches';
    else if (menuName === 'งานที่บันทึก') tab = 'saved_jobs';
    else if (menuName === 'ประวัติการสมัครงาน') tab = 'history';
    else if (menuName === 'การตั้งค่า') tab = 'settings';

    navigate(`/jobs/profile?tab=${tab}`);
  };

  return (
    <>
      <nav className='job-navbar'>
        <div className='job-nav-container'>
          <div className='job-nav-logo' onClick={() => navigate('/jobs')}>
            <div className='job-logo-img-wrap'>
              <img src={meya_logo} alt='Meya Logo' />
            </div>
            <div className='job-logo-text'>
              <span className='job-logo-main'>JobsMeya</span>
              <span className='job-logo-sub'>หางานสายสุขภาพ</span>
            </div>
          </div>

          {isJobLoggedIn && (
            <div className='job-nav-links-desktop'>
              <span className='job-nav-link' onClick={() => navigate('/jobs')}>
                ตำแหน่งงาน
              </span>
              {isShopMember && (
                <span className='job-nav-link' onClick={() => navigate('/jobs?mode=candidates')}>
                  คนหางาน
                </span>
              )}
              <span className='job-nav-link' onClick={() => navigate(onlineShopPath)}>
                ร้านค้าออนไลน์
              </span>
            </div>
          )}

          <div className='job-nav-actions-end'>
            <div className='job-nav-actions-desktop'>
              {isJobLoggedIn ? (
                <div className='job-profile-dropdown-container'>
                  <div
                    className='job-profile-trigger'
                    onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                  >
                    <i className='mdi mdi-account-circle-outline'></i> สวัสดีคุณ{' '}
                    {regName || 'Admin'}
                  </div>

                  {isProfileDropdownOpen && (
                    <div className='job-profile-dropdown-menu'>
                      {isShopMember ? (
                        <>
                          <div
                            className='dropdown-header text-muted'
                            style={{ fontSize: '11px', padding: '6px 16px', fontWeight: 600 }}
                          >
                            <i className='mdi mdi-domain me-1'></i> บัญชีผู้ประกอบการ
                          </div>
                          <div
                            className='dropdown-item'
                            onClick={() => {
                              setIsProfileDropdownOpen(false);
                              navigate('/jobs/employer');
                            }}
                          >
                            <i className='mdi mdi-view-dashboard-outline me-2 text-primary'></i>{' '}
                            แดชบอร์ดผู้ประกอบการ
                          </div>
                          <div
                            className='dropdown-item'
                            onClick={() => {
                              setIsProfileDropdownOpen(false);
                              navigate('/jobs/employer?tab=post_job');
                            }}
                          >
                            <i className='mdi mdi-plus-circle-outline me-2 text-success'></i>{' '}
                            ลงประกาศรับสมัครงาน
                          </div>
                          <div
                            className='dropdown-item'
                            onClick={() => {
                              setIsProfileDropdownOpen(false);
                              navigate('/jobs/employer?tab=manage_jobs');
                            }}
                          >
                            <i className='mdi mdi-format-list-bulleted me-2'></i>{' '}
                            จัดการประกาศงานของฉัน
                          </div>
                          <div
                            className='dropdown-item'
                            onClick={() => {
                              setIsProfileDropdownOpen(false);
                              navigate('/jobs/employer?tab=applicants');
                            }}
                          >
                            <i className='mdi mdi-account-group-outline me-2'></i>{' '}
                            ตรวจสอบผู้สมัครงาน
                          </div>
                          <div
                            className='dropdown-item'
                            onClick={() => {
                              setIsProfileDropdownOpen(false);
                              navigate('/jobs?mode=candidates');
                            }}
                          >
                            <i className='mdi mdi-account-search-outline me-2'></i> ค้นหาคนทำงาน
                            (Candidates)
                          </div>
                          <hr className='dropdown-divider' />
                          <div
                            className='dropdown-item'
                            onClick={() => {
                              setIsProfileDropdownOpen(false);
                              navigate(onlineShopPath);
                            }}
                          >
                            <i className='mdi mdi-store-outline me-2'></i> ไปหน้าร้านค้าออนไลน์
                          </div>
                          <hr className='dropdown-divider' />
                          <div
                            className='dropdown-item logout-item'
                            onClick={() => {
                              setIsProfileDropdownOpen(false);
                              onJobLogout();
                            }}
                          >
                            <i className='mdi mdi-logout me-1 text-danger'></i> กลับหน้าร้านค้า
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className='dropdown-header text-muted'
                            style={{ fontSize: '11px', padding: '6px 16px', fontWeight: 600 }}
                          >
                            <i className='mdi mdi-account-outline me-1'></i> บัญชีผู้หางาน
                          </div>
                          <div
                            className='dropdown-item'
                            onClick={() => handleMenuClick('สร้าง/แก้ไขโปรไฟล์')}
                          >
                            <i className='mdi mdi-account-edit-outline me-1'></i>{' '}
                            สร้าง/แก้ไขโปรไฟล์ผู้หางาน
                          </div>
                          <hr className='dropdown-divider' />
                          <div
                            className='dropdown-item'
                            onClick={() => handleMenuClick('บันทึกการค้นหา')}
                          >
                            <i className='mdi mdi-magnify me-1'></i> บันทึกการค้นหา
                          </div>
                          <div
                            className='dropdown-item'
                            onClick={() => handleMenuClick('งานที่บันทึก')}
                          >
                            <i className='mdi mdi-heart-outline me-1'></i> งานที่บันทึก
                          </div>
                          <div
                            className='dropdown-item'
                            onClick={() => handleMenuClick('ประวัติการสมัครงาน')}
                          >
                            <i className='mdi mdi-history me-1'></i> ประวัติการสมัครงาน
                          </div>
                          <div
                            className='dropdown-item'
                            onClick={() => handleMenuClick('การตั้งค่า')}
                          >
                            <i className='mdi mdi-cog-outline me-1'></i> การตั้งค่า
                          </div>
                          <hr className='dropdown-divider' />
                          <div
                            className='dropdown-item logout-item'
                            onClick={() => {
                              setIsProfileDropdownOpen(false);
                              onJobLogout();
                            }}
                          >
                            <i className='mdi mdi-logout me-1 text-danger'></i> ออกจากระบบหางาน
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <button
                  type='button'
                  className='btn-job-navbar-action login'
                  onClick={() => navigate(onlineShopPath)}
                >
                  ไปหน้าร้านค้าออนไลน์
                </button>
              )}
            </div>

            {isJobLoggedIn && (
              <button
                type='button'
                className='job-hamburger-btn'
                onClick={toggleMenu}
                aria-label='เปิดเมนู'
              >
                {isMenuOpen ? <IoClose size={24} /> : <IoMenu size={24} />}
              </button>
            )}
          </div>
        </div>
      </nav>

      {isJobLoggedIn && (
        <div className={`job-mobile-drawer ${isMenuOpen ? 'open' : ''}`}>
          <div className='job-drawer-header'>
            <div className='job-drawer-user-info'>
              <div className='job-drawer-user-avatar'>
                <i className={isShopMember ? 'mdi mdi-domain' : 'mdi mdi-account-circle'}></i>
              </div>
              <div className='job-drawer-user-text'>
                <span className='job-drawer-user-name'>{regName || 'Admin'}</span>
                <span className='job-drawer-user-role'>
                  {isShopMember ? 'ผู้ประกอบการ / ร้านค้า' : 'สมาชิก JobsMeya'}
                </span>
              </div>
            </div>
            <button
              type='button'
              className='job-drawer-close-btn'
              onClick={toggleMenu}
              aria-label='ปิดเมนู'
            >
              <IoClose size={22} />
            </button>
          </div>

          <div className='job-drawer-content'>
            <div className='job-drawer-nav-section'>
              <span className='job-drawer-section-title'>เมนูหลัก</span>
              <div className='job-drawer-nav-links'>
                <span
                  className='job-drawer-link'
                  onClick={() => {
                    navigate('/jobs');
                    toggleMenu();
                  }}
                >
                  <i className='mdi mdi-briefcase-search-outline me-2'></i> ค้นหาตำแหน่งงาน
                </span>
                {isShopMember && (
                  <span
                    className='job-drawer-link'
                    onClick={() => {
                      navigate('/jobs?mode=candidates');
                      toggleMenu();
                    }}
                  >
                    <i className='mdi mdi-account-search-outline me-2'></i> ค้นหาคนทำงาน
                  </span>
                )}
                <span
                  className='job-drawer-link'
                  onClick={() => {
                    navigate(onlineShopPath);
                    toggleMenu();
                  }}
                >
                  <i className='mdi mdi-store-outline me-2'></i> ไปหน้าร้านค้าออนไลน์
                </span>
              </div>
            </div>

            <div className='job-drawer-nav-section'>
              <span className='job-drawer-section-title'>
                {isShopMember ? 'จัดการร้านค้า/ผู้ประกอบการ' : 'บัญชีของฉัน'}
              </span>
              <div className='job-drawer-nav-links'>
                {isShopMember ? (
                  <>
                    <span
                      className='job-drawer-setting-link'
                      onClick={() => {
                        navigate('/jobs/employer');
                        toggleMenu();
                      }}
                    >
                      <i className='mdi mdi-view-dashboard-outline me-2 text-primary'></i>{' '}
                      แดชบอร์ดผู้ประกอบการ
                    </span>
                    <span
                      className='job-drawer-setting-link'
                      onClick={() => {
                        navigate('/jobs/employer?tab=post_job');
                        toggleMenu();
                      }}
                    >
                      <i className='mdi mdi-plus-circle-outline me-2 text-success'></i>{' '}
                      ลงประกาศรับสมัครงาน
                    </span>
                    <span
                      className='job-drawer-setting-link'
                      onClick={() => {
                        navigate('/jobs/employer?tab=manage_jobs');
                        toggleMenu();
                      }}
                    >
                      <i className='mdi mdi-format-list-bulleted me-2'></i> จัดการประกาศงานของฉัน
                    </span>
                    <span
                      className='job-drawer-setting-link'
                      onClick={() => {
                        navigate('/jobs/employer?tab=applicants');
                        toggleMenu();
                      }}
                    >
                      <i className='mdi mdi-account-group-outline me-2'></i> ตรวจสอบผู้สมัครงาน
                    </span>
                  </>
                ) : (
                  <>
                    <span
                      className='job-drawer-setting-link'
                      onClick={() => handleMenuClick('สร้าง/แก้ไขโปรไฟล์')}
                    >
                      สร้าง/แก้ไขโปรไฟล์ผู้หางาน
                    </span>
                    <span
                      className='job-drawer-setting-link'
                      onClick={() => handleMenuClick('บันทึกการค้นหา')}
                    >
                      บันทึกการค้นหา
                    </span>
                    <span
                      className='job-drawer-setting-link'
                      onClick={() => handleMenuClick('งานที่บันทึก')}
                    >
                      งานที่บันทึก
                    </span>
                    <span
                      className='job-drawer-setting-link'
                      onClick={() => handleMenuClick('ประวัติการสมัครงาน')}
                    >
                      ประวัติการสมัครงาน
                    </span>
                    <span
                      className='job-drawer-setting-link'
                      onClick={() => handleMenuClick('การตั้งค่า')}
                    >
                      การตั้งค่า
                    </span>
                  </>
                )}
              </div>

              <button
                type='button'
                className='btn-job-navbar-action logout w-100 mt-3'
                onClick={() => {
                  onJobLogout();
                  toggleMenu();
                }}
              >
                {isShopMember ? 'กลับหน้าร้านค้า' : 'ออกจากระบบหางาน'}
              </button>
            </div>
          </div>
        </div>
      )}

      {isJobLoggedIn && isMenuOpen && (
        <div className='job-drawer-overlay' onClick={toggleMenu}></div>
      )}
    </>
  );
}

export default JobNavBar;
